import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=5b1c3e6f&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"
import style0 from "./Stores.vue?vue&type=style&index=0&id=5b1c3e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c3e6f",
  null
  
)

export default component.exports